import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthServiceService } from './services/auth-service/auth-service.service';

@Component({
    selector: 'app-my-app',
    templateUrl: './app.component.html'
})

export class AppComponent implements OnInit, OnDestroy {
  private _router?: Subscription;

  constructor(private router: Router, private authService: AuthServiceService) {
  }

    ngOnInit() {
      this.authService.initializeSessionMonitoring();
      this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        const body = document.getElementsByTagName('body')[0];
        const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
        if (body.classList.contains('modal-open')) {
          body.classList.remove('modal-open');
          modalBackdrop?.remove();
        }
      });
    }

    ngOnDestroy() {
      this._router?.unsubscribe();
    }
}
